import { render, staticRenderFns } from "./ConfirmationMessage2El.vue?vue&type=template&id=1a016ed9&scoped=true&"
import script from "./ConfirmationMessage2El.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationMessage2El.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationMessage2El.vue?vue&type=style&index=0&id=1a016ed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a016ed9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
